import { effects } from './effects';
import { exportModule } from './module';
import { state } from './state';

export const CurrentOrLegacyReportingModule = exportModule({
  state,
  effects
});
